// extracted by mini-css-extract-plugin
export default {"container":"style_container__hTyzK","cardChild":"style_cardChild__eSquO","formStyle":"style_formStyle__TrbiJ","footer":"style_footer__6nmWi"};